import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import {
  OrderSellerData,
  OrderSellerQuery,
  OrderSellerDetailData,
  OrderSellerDisputeData,
  OrderSellerDeliveryViewData,
  SellerDisputeConfirmQuery
} from '@/api/member/sold-order/types';

/**
 * 获取卖家所有订单列表
 */

export const getOrderSellerList = (query?: OrderSellerQuery): AxiosPromise<OrderSellerData[]> =>
  request({
    url: '/api/order/seller/list',
    method: 'get',
    params: query
  });

/**
 * 获取待发货/发货中状态的订单列表
 */
export const getOrderSellerDeliveringList = (query?: OrderSellerQuery): AxiosPromise<OrderSellerData[]> =>
  request({
    url: '/api/order/seller/pending/list',
    method: 'get',
    params: query
  });

/**
 * 获取争议中的订单列表
 */
export const getOrderSellerDisputeList = (query?: OrderSellerQuery): AxiosPromise<OrderSellerData[]> =>
  request({
    url: '/api/order/seller/dispute/list',
    method: 'get',
    params: query
  });

/**
 * 订单详情
 */
export const getOrderSellerDetail = (orderId: string | number): AxiosPromise<OrderSellerDetailData> =>
  request({
    url: '/api/order/seller/detail/' + orderId,
    method: 'get'
  });

/**
 * 争议详情
 */
export const getOrderSellerDisputeDetail = (query: string | number): AxiosPromise<OrderSellerDisputeData> =>
  request({
    url: '/api/order/seller/dispute/detail',
    method: 'get',
    params: { disputeId: query }
  });

/**
 * 卖家查看发货信息 topUp代充，代练 需要邮箱验证
 */
export const getOrderSellerDeliveryView = (query: {
  orderId: string | number;
  code?: string;
}): AxiosPromise<OrderSellerDeliveryViewData> =>
  request({
    url: '/api/order/seller/delivery/view',
    method: 'get',
    params: query
  });

/**
 * 邮箱验证码
 */
export const getOrderSellerDeliveryViewCode = (query: { orderId: string | number }): AxiosPromise<{ email: string }> =>
  request({
    url: '/api/order/seller/email/code',
    method: 'post',
    data: query
  });

/**
 * 买家发起争议，卖家确认
 */
export const getSellerDisputeConfirm = (data: SellerDisputeConfirmQuery): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/seller/dispute/confirm',
    method: 'post',
    data
  });
};

/**
 * 卖家开始发货
 *
 */
export const getSellerDeliveryStart = (data: { orderId: string | number }): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/seller/delivery/start',
    method: 'post',
    data
  });
};

/**
 * 发货完成
 *
 */
export const getSellerDeliveryEnd = (data: {
  orderId: string | number;
  deliveryInfo?: string;
  proofList?: number[];
  remarh?: string;
}): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/seller/delivery/complete',
    method: 'post',
    data
  });
};

// 计算争议可退款金额，推算出买家退款金额
export const getDisputeRefundAmount = (data: {
  orderId: string | number;
  partFlag?: number;
  refundAmount?: number;
}): AxiosPromise<{ canRefundAmount: string; buyerRefundAmount: string; currency: string }> => {
  return request({
    url: '/api/order/seller/dispute/refund/info',
    method: 'post',
    data
  });
};
